(function () {
  'use strict';

  var select = document.querySelector('[data-topic-select]');
  var recipesToggle = document.querySelector('[data-recipes-toggle]');
  var grid = document.querySelector('[data-post-grid]');
  var featuredSection = document.querySelector('[data-featured-section]');
  var featuredDuplicate = document.querySelector('[data-featured-duplicate]');
  var countEl = document.querySelector('[data-post-count]');
  var emptyMessage = document.querySelector('[data-empty-message]');

  if (!grid) return;

  var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-post-tile]'));
  var recipesOnly = false;

  function apply() {
    var topic = select ? select.value : 'all';
    var isDefault = topic === 'all' && !recipesOnly;
    var visible = 0;

    tiles.forEach(function (tile) {
      var matchesTopic = topic === 'all' || tile.dataset.category === topic;
      var matchesType = !recipesOnly || tile.dataset.type === 'recipe';
      var isFeaturedDup = featuredDuplicate && featuredDuplicate.contains(tile);
      var show = matchesTopic && matchesType && !(isDefault && isFeaturedDup);
      // The featured-duplicate tile is wrapped in its own [data-featured-duplicate]
      // div (so it can be targeted separately from the plain tiles below it) - that
      // wrapper, not the tile itself, is the grid's actual direct child. Hiding only
      // the inner tile leaves the wrapper as an empty grid cell (a visible gap);
      // hiding the wrapper removes it from grid flow entirely.
      if (isFeaturedDup) {
        featuredDuplicate.hidden = !show;
      } else {
        tile.hidden = !show;
      }
      if (show) visible++;
    });

    if (featuredSection) featuredSection.hidden = !isDefault;
    if (emptyMessage) emptyMessage.hidden = visible !== 0;
    if (countEl) countEl.textContent = visible + ' article' + (visible === 1 ? '' : 's');
  }

  if (select) {
    select.addEventListener('change', function () {
      apply();
    });
  }

  if (recipesToggle) {
    recipesToggle.addEventListener('click', function () {
      recipesOnly = !recipesOnly;
      recipesToggle.classList.toggle('is-active', recipesOnly);
      if (recipesOnly && select) select.value = 'all';
      apply();
    });
  }

  // The homepage's "All recipes" button links here with #recipes.
  if (recipesToggle && window.location.hash === '#recipes') {
    recipesOnly = true;
    recipesToggle.classList.add('is-active');
  }

  apply();
})();
